import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { TicketApi } from "services/ticket";
import { Utils } from "services/utils";
import { ActionButton } from "styled_components/Common/ActionButton";
import { createTicketImage, getTicketTitle } from "utils/SupportUtils";
import LoadingCube from "sub_components/Common/LoadingCube";

const RecentTicketsStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 110px;
  padding: 10px;
  flex: 1;
  white-space: pre-line;
  background: ${(props) => props.theme.componentBackground};
  color: ${(props) => props.theme.defaultFontColor};
  &.loading {
    background: transparent;
  }

  .recent-ticket-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .recent-ticket {
      width: 85px;
      height: 85px;
      color: ${(props) => props.theme.defaultFontColor};
      img {
        width: 35px;
        height: 35px;
        margin-top: 5px;
        margin-bottom: 5px;
      }
      .title {
        text-transform: capitalize;
      }
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    width: 430px;
    height: 135px;
    padding: 10px;

    .recent-ticket-wrapper {
      .recent-ticket {
        width: 105px;
        height: 105px;
        img {
          width: 40px;
          height: 40px;
          margin-top: 5px;
          margin-bottom: 5px;
        }
      }
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    width: 800px !important;

    padding: 10px;

    .recent-ticket-wrapper {
      .recent-ticket {
        width: 200px;
        height: 200px;
        img {
          width: 75px;
          height: 75px;
          margin-top: 10px;
          margin-bottom: 10px;
        }
      }
    }
  }
`;

export const RecentTickets = ({
  orgId,
  onSelectTicket,
  ticketType,
  update,
}) => {
  const [tickets, setTickets] = useState(null);
  const [loading, setLoading] = useState(false);

  const getRecentTickets = async () => {
    try {
      if (ticketType?.bonita) {
        const cachedTicketsString = sessionStorage.getItem("tickets");
        if (cachedTicketsString) {
          try {
            const cachedTickets = JSON.parse(cachedTicketsString);
            if (cachedTickets && cachedTickets.orgId === orgId) {
              const recentTickets = cachedTickets.tickets.slice(0, 3);
              if (recentTickets.length > 0) {
                setTickets(Utils.sort(recentTickets).slice(0, 3));
                return;
              }
            }
          } catch (error) {
            console.error(
              "Error parsing cached tickets for recent tickets:",
              error
            );
          }
        }
        setLoading(true);
        const response = await TicketApi.getRecentTickets(3, orgId);
        if (response.status === 200 && response.data) {
          setTickets(Utils.sort(response.data.tickets).slice(0, 3));

          if (!cachedTicketsString) {
            const ticketsCache = {
              tickets: response.data.tickets,
              orgId: orgId,
              timestamp: new Date().getTime(),
            };

            sessionStorage.setItem("tickets", JSON.stringify(ticketsCache));
          }
        }
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getRecentTickets();
  }, [ticketType, update]);

  return (
    <RecentTicketsStyle
      className={
        loading ? "recent-tickets-wrapper loading" : "recent-tickets-wrapper"
      }
    >
      {loading ? (
        <div className="loading-container">
          <LoadingCube size={40} color="support" />
        </div>
      ) : (
        tickets &&
        tickets.map((ticket, index) => (
          <div className="recent-ticket-wrapper" key={ticket.id}>
            <ActionButton
              cypressId={`recent-ticket-${index}`}
              module="support"
              className="recent-ticket"
              id={`recent-ticket-${index}`}
              onClick={() => onSelectTicket(ticket)}
            >
              <img
                src={createTicketImage(ticket?.name).image}
                alt="ticket type"
              />
              <div className="title header52">
                {getTicketTitle(ticket?.name)}
              </div>
              <div className="number labels21">{`# ${ticket?.id}`}</div>
            </ActionButton>
          </div>
        ))
      )}
    </RecentTicketsStyle>
  );
};
